export default __webpack_public_path__ + "static/media/oni_white.21ba18a2.svg";